/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiReportExportCouresReportPost } from '../fn/report/api-report-export-coures-report-post';
import { ApiReportExportCouresReportPost$Params } from '../fn/report/api-report-export-coures-report-post';
import { apiReportExportCreditDebitDailyPost } from '../fn/report/api-report-export-credit-debit-daily-post';
import { ApiReportExportCreditDebitDailyPost$Params } from '../fn/report/api-report-export-credit-debit-daily-post';
import { apiReportExportEtaxReportPost } from '../fn/report/api-report-export-etax-report-post';
import { ApiReportExportEtaxReportPost$Params } from '../fn/report/api-report-export-etax-report-post';
import { apiReportExportInvoiceDailyPost } from '../fn/report/api-report-export-invoice-daily-post';
import { ApiReportExportInvoiceDailyPost$Params } from '../fn/report/api-report-export-invoice-daily-post';
import { apiReportExportPaymentDailyPost } from '../fn/report/api-report-export-payment-daily-post';
import { ApiReportExportPaymentDailyPost$Params } from '../fn/report/api-report-export-payment-daily-post';
import { apiReportExportPost } from '../fn/report/api-report-export-post';
import { ApiReportExportPost$Params } from '../fn/report/api-report-export-post';
import { apiReportGetCreditDebitDailyPost } from '../fn/report/api-report-get-credit-debit-daily-post';
import { ApiReportGetCreditDebitDailyPost$Params } from '../fn/report/api-report-get-credit-debit-daily-post';
import { apiReportGetETaxReportPost } from '../fn/report/api-report-get-e-tax-report-post';
import { ApiReportGetETaxReportPost$Params } from '../fn/report/api-report-get-e-tax-report-post';
import { apiReportGetFinanicalReportPost } from '../fn/report/api-report-get-finanical-report-post';
import { ApiReportGetFinanicalReportPost$Params } from '../fn/report/api-report-get-finanical-report-post';
import { apiReportGetInvoiceDailyPost } from '../fn/report/api-report-get-invoice-daily-post';
import { ApiReportGetInvoiceDailyPost$Params } from '../fn/report/api-report-get-invoice-daily-post';
import { apiReportGetPaymentDailyPost } from '../fn/report/api-report-get-payment-daily-post';
import { ApiReportGetPaymentDailyPost$Params } from '../fn/report/api-report-get-payment-daily-post';
import { EtaxReport } from '../models/etax-report';
import { FinanceReport } from '../models/finance-report';
import { PaymentDaily } from '../models/payment-daily';

@Injectable({ providedIn: 'root' })
export class ReportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiReportGetFinanicalReportPost()` */
  static readonly ApiReportGetFinanicalReportPostPath = '/api/Report/GetFinanicalReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportGetFinanicalReportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetFinanicalReportPost$Response(params?: ApiReportGetFinanicalReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FinanceReport>>> {
    return apiReportGetFinanicalReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportGetFinanicalReportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetFinanicalReportPost(params?: ApiReportGetFinanicalReportPost$Params, context?: HttpContext): Observable<Array<FinanceReport>> {
    return this.apiReportGetFinanicalReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FinanceReport>>): Array<FinanceReport> => r.body)
    );
  }

  /** Path part for operation `apiReportExportPost()` */
  static readonly ApiReportExportPostPath = '/api/Report/Export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportExportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportPost$Response(params?: ApiReportExportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiReportExportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportExportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportPost(params?: ApiReportExportPost$Params, context?: HttpContext): Observable<string> {
    return this.apiReportExportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiReportExportCouresReportPost()` */
  static readonly ApiReportExportCouresReportPostPath = '/api/Report/ExportCouresReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportExportCouresReportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportCouresReportPost$Response(params?: ApiReportExportCouresReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiReportExportCouresReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportExportCouresReportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportCouresReportPost(params?: ApiReportExportCouresReportPost$Params, context?: HttpContext): Observable<string> {
    return this.apiReportExportCouresReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiReportGetETaxReportPost()` */
  static readonly ApiReportGetETaxReportPostPath = '/api/Report/GetETaxReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportGetETaxReportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetETaxReportPost$Response(params?: ApiReportGetETaxReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EtaxReport>>> {
    return apiReportGetETaxReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportGetETaxReportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetETaxReportPost(params?: ApiReportGetETaxReportPost$Params, context?: HttpContext): Observable<Array<EtaxReport>> {
    return this.apiReportGetETaxReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<EtaxReport>>): Array<EtaxReport> => r.body)
    );
  }

  /** Path part for operation `apiReportExportEtaxReportPost()` */
  static readonly ApiReportExportEtaxReportPostPath = '/api/Report/ExportEtaxReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportExportEtaxReportPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportEtaxReportPost$Response(params?: ApiReportExportEtaxReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiReportExportEtaxReportPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportExportEtaxReportPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportEtaxReportPost(params?: ApiReportExportEtaxReportPost$Params, context?: HttpContext): Observable<string> {
    return this.apiReportExportEtaxReportPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiReportGetPaymentDailyPost()` */
  static readonly ApiReportGetPaymentDailyPostPath = '/api/Report/GetPaymentDaily';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportGetPaymentDailyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetPaymentDailyPost$Response(params?: ApiReportGetPaymentDailyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentDaily>>> {
    return apiReportGetPaymentDailyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportGetPaymentDailyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetPaymentDailyPost(params?: ApiReportGetPaymentDailyPost$Params, context?: HttpContext): Observable<Array<PaymentDaily>> {
    return this.apiReportGetPaymentDailyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentDaily>>): Array<PaymentDaily> => r.body)
    );
  }

  /** Path part for operation `apiReportExportPaymentDailyPost()` */
  static readonly ApiReportExportPaymentDailyPostPath = '/api/Report/ExportPaymentDaily';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportExportPaymentDailyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportPaymentDailyPost$Response(params?: ApiReportExportPaymentDailyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiReportExportPaymentDailyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportExportPaymentDailyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportPaymentDailyPost(params?: ApiReportExportPaymentDailyPost$Params, context?: HttpContext): Observable<string> {
    return this.apiReportExportPaymentDailyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiReportGetInvoiceDailyPost()` */
  static readonly ApiReportGetInvoiceDailyPostPath = '/api/Report/GetInvoiceDaily';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportGetInvoiceDailyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetInvoiceDailyPost$Response(params?: ApiReportGetInvoiceDailyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentDaily>>> {
    return apiReportGetInvoiceDailyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportGetInvoiceDailyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetInvoiceDailyPost(params?: ApiReportGetInvoiceDailyPost$Params, context?: HttpContext): Observable<Array<PaymentDaily>> {
    return this.apiReportGetInvoiceDailyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentDaily>>): Array<PaymentDaily> => r.body)
    );
  }

  /** Path part for operation `apiReportExportInvoiceDailyPost()` */
  static readonly ApiReportExportInvoiceDailyPostPath = '/api/Report/ExportInvoiceDaily';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportExportInvoiceDailyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportInvoiceDailyPost$Response(params?: ApiReportExportInvoiceDailyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiReportExportInvoiceDailyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportExportInvoiceDailyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportInvoiceDailyPost(params?: ApiReportExportInvoiceDailyPost$Params, context?: HttpContext): Observable<string> {
    return this.apiReportExportInvoiceDailyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiReportGetCreditDebitDailyPost()` */
  static readonly ApiReportGetCreditDebitDailyPostPath = '/api/Report/GetCreditDebitDaily';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportGetCreditDebitDailyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetCreditDebitDailyPost$Response(params?: ApiReportGetCreditDebitDailyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PaymentDaily>>> {
    return apiReportGetCreditDebitDailyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportGetCreditDebitDailyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportGetCreditDebitDailyPost(params?: ApiReportGetCreditDebitDailyPost$Params, context?: HttpContext): Observable<Array<PaymentDaily>> {
    return this.apiReportGetCreditDebitDailyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PaymentDaily>>): Array<PaymentDaily> => r.body)
    );
  }

  /** Path part for operation `apiReportExportCreditDebitDailyPost()` */
  static readonly ApiReportExportCreditDebitDailyPostPath = '/api/Report/ExportCreditDebitDaily';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiReportExportCreditDebitDailyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportCreditDebitDailyPost$Response(params?: ApiReportExportCreditDebitDailyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiReportExportCreditDebitDailyPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiReportExportCreditDebitDailyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiReportExportCreditDebitDailyPost(params?: ApiReportExportCreditDebitDailyPost$Params, context?: HttpContext): Observable<string> {
    return this.apiReportExportCreditDebitDailyPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
